import { render, staticRenderFns } from "./NoticeArea.vue?vue&type=template&id=5a938af0"
import script from "./NoticeArea.vue?vue&type=script&lang=js"
export * from "./NoticeArea.vue?vue&type=script&lang=js"
import style0 from "./NoticeArea.vue?vue&type=style&index=0&id=5a938af0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports